export default __webpack_public_path__ + "static/media/maths2.a458eefe.png";